import React from 'react';
import './accordionStyle.css';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

const XBAccordion = React.memo(({ title, body, isActive, setTabItem, currentTabItem }) => {
  const handleClick = () => {
    if (isActive) {
      // If already active, close it by setting tabItem to null
      setTabItem(null);
    } else {
      // If not active, open it by setting tabItem to currentTabItem
      setTabItem(currentTabItem);
    }
  };

  return (
    <div className={`xb_accordion_box ${isActive ? 'active' : ''}`}>
      <div onClick={handleClick} className="xb_accordion_label sm:text-[1rem] sm:px-5">
        {title}
        {isActive ? <MdKeyboardArrowUp size={26} /> : <MdKeyboardArrowDown size={26} />}
      </div>
      <div className="xb_accordion_content sm:text-sm sm:px-5">
        <p>{body}</p>
      </div>
    </div>
  );
});

export default XBAccordion;
